export default __webpack_public_path__ + "static/media/platform.20ac79d3.png";